module.exports = __webpack_public_path__ + "static/media/Pistachiodelish.13634e8e.jpg";